// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".t-orm-item:nth-child(2n){background-color:#f7f7f7}.t-orm-item .v-icon{font-size:18px}.t-orm-item .v-input--checkbox input,.t-orm-item .v-radio input{cursor:default}.disabled{opacity:.5}", ""]);
// Exports
module.exports = exports;
